import { Box, HStack, Header, Pressable, VStack } from '@rbilabs/universal-components';

import {
  ModalContent as OriginalModalContent,
  ModalHeading as OriginalModalHeading,
} from 'components/modal';

export const ModalHeading = OriginalModalHeading.withConfig({
  alignSelf: 'center',
  maxWidth: {
    md: '$64',
  },
});

export const ModalContent = OriginalModalContent.withConfig({
  width: {
    md: 'full',
  },
  marginX: {
    md: '$16',
  },
});

export const Section = HStack.withConfig({
  width: 'full',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  marginTop: '$9',
});

export const ModeColumn = VStack.withConfig({
  flex: 1,
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
});

export const StyledButton = Pressable.withConfig<{ disabled: boolean }>(p => ({
  width: 'full',
  borderBottomWidth: '1px',
  borderBottomColor: Styles.color.grey.four,
  paddingLeft: '$4',

  _web: {
    _hover: {
      backgroundColor: Styles.color.grey.five,
      _text: {
        color: Styles.color.grey.five,
      },
      cursor: p.disabled ? 'not-allowed' : 'pointer',
    },
  },
}));

export const IconWrapper = HStack.withConfig({
  justifyContent: 'center',
  alignItems: 'flex-start',
  marginRight: {
    base: '$3.5',
    md: '$5',
  },
  marginTop: '$0.5',
});

export const TextRow = Box.withConfig<{ isTitle?: boolean }>(({ isTitle }) => ({
  width: 'full',
  _text: {
    textAlign: 'start',
  },
  margin: '$0',
  paddingTop: isTitle ? '$0' : '$2.5',
  paddingBottom: isTitle ? '$4' : '$3',
  paddingX: '$0',
  borderBottomWidth: isTitle ? '1' : '0',
  borderBottomColor: isTitle ? Styles.color.grey.four : 'transparent',
}));

export const Title = Header.withConfig({
  lineHeight: 'sm',
  fontSize: '2xl',
  color: Styles.color.black,
  textTransform: 'uppercase',
  fontFamily: 'heading',
  fontWeight: 'normal',
});

export const Mode = Header.withConfig<{ disabled: boolean }>(p => ({
  fontSize: 'md',
  fontFamily: 'heading',
  color: p.disabled ? Styles.color.grey.two : Styles.color.grey.one,
}));
